function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m3.806 80.654c0-44.939 36.754-81.294 81.842-80.645 43.675.628 79.188 36.446 79.464 80.124.155 24.461-10.583 46.414-27.645 61.305-1.801 1.571-1.541 4.439.516 5.656l15.197 8.992c2.457 1.454 1.426 5.22-1.429 5.22l-68.818-.017c-43.839-.815-79.127-36.602-79.127-80.635z",
  fill: "#7acaa6"
}))), /*#__PURE__*/React.createElement("path", {
  d: "m153.18 156.086-15.198-8.992c-2.046-1.21-2.33-4.074-.539-5.636 17.257-15.049 28.051-37.322 27.66-62.108-.677-42.873-35.377-78.066-78.238-79.315-6.078-.177-12.01.32-17.727 1.419 37.047 7.102 65.281 39.757 65.527 78.678.119 18.849-6.23 36.209-16.956 49.996-6.477 8.325-4.372 20.397 4.706 25.769l.318.188c2.43 1.438 1.444 5.132-1.339 5.212l30.356.007c2.855.002 3.887-3.765 1.43-5.218z",
  fill: "#57be92"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m396.792 292.755h-182.966c-45.698 0-70.706-53.256-41.519-88.42l1.623-1.956c12.858-15.491 19.896-34.99 19.896-55.122v-35.283c.001-61.842 50.133-111.974 111.975-111.974 61.842 0 111.974 50.132 111.974 111.974v36.474c0 20.343 7.186 40.032 20.29 55.593 29.551 35.092 4.605 88.714-41.273 88.714z",
  fill: "#c59191"
}), /*#__PURE__*/React.createElement("path", {
  d: "m492.97 383.43v120.96h-375.32v-120.05c0-27.18 16.29-51.71 41.33-62.25l60.59-26.34 20.4-8.87c15.48-6.73 25.49-22 25.49-38.88v-7.83h79.69v7.43c0 16.95 10.11 32.28 25.7 38.96l81.95 35.13c24.42 10.82 40.17 35.02 40.17 61.74z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m219.565 324.59c20.679 6.179 51.116 12.769 88.217 12.12 34.811-.608 63.387-7.377 83.271-13.728l9.88-23.527-30.086-12.895c-15.586-6.681-25.692-22.006-25.692-38.964v-7.424h-79.69v7.828c0 16.878-10.012 32.147-25.489 38.877l-24.368 10.595z",
  fill: "#ffcebf"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#8795de"
}, /*#__PURE__*/React.createElement("path", {
  d: "m452.796 321.685-61.732-26.459-.011.001v209.161h101.918v-120.957c0-26.717-15.749-50.922-40.175-61.746z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m219.57 295.75v208.64h-101.92v-120.05c0-27.18 16.29-51.71 41.33-62.25z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m332.933 283.912c9.168 0 17.904-1.841 25.867-5.163-8.542-7.885-13.646-19.105-13.646-31.152v-7.424h-79.69v7.827c0 6.097-1.313 11.982-3.712 17.332 12.067 11.503 28.392 18.579 46.379 18.579h24.802z",
  fill: "#ffb09e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m384.957 120.293v65.925c0 37.14-30.108 67.247-67.247 67.247h-24.801c-37.14 0-67.247-30.108-67.247-67.247v-65.925c0-24.161 19.586-43.748 43.748-43.748h71.8c24.161.001 43.747 19.587 43.747 43.748z",
  fill: "#ffcebf"
}), /*#__PURE__*/React.createElement("path", {
  d: "m384.957 154.593c-.03.091-.067.179-.094.272-2.431 8.395-8.811 24.253-24.229 36.142-7.179 5.537-15.368 9.537-24.338 11.891-4.066 1.067-6.498 5.228-5.431 9.294.898 3.419 3.981 5.682 7.358 5.682.639 0 1.289-.081 1.937-.251 10.952-2.874 20.968-7.773 29.771-14.56 6.079-4.688 10.999-9.866 14.982-15.072.015-.59.045-1.177.045-1.771v-31.627z",
  fill: "#7a6d79"
}), /*#__PURE__*/React.createElement("path", {
  d: "m327.949 223.939h-17.837c-8.119 0-14.701-6.582-14.701-14.701 0-8.119 6.582-14.701 14.701-14.701h17.837c8.119 0 14.701 6.582 14.701 14.701-.001 8.12-6.582 14.701-14.701 14.701z",
  fill: "#685e68"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m321.201 59.097c1.708-21.54 22.33-35.835 42.067-43.239 32.649 19.563 54.507 55.284 54.507 96.115v7.698c-1.805.379-3.601.711-5.377.976-10.873 1.624-20.132.921-26.458 0-40.763-5.43-66.802-35.535-64.739-61.55z",
  fill: "#b98080"
}), /*#__PURE__*/React.createElement("path", {
  d: "m305.801 0c25.288 0 48.616 8.386 67.361 22.525-9.351 16.271-30.823 48.441-71.086 72.257-29.89 17.681-58.074 23.622-75.43 25.865h-32.818v-8.674c-.001-61.841 50.131-111.973 111.973-111.973z",
  fill: "#c59191"
})))), /*#__PURE__*/React.createElement("path", {
  d: "m430.971 504.388h-243.654l-13.439-126.775c-.953-8.992 6.096-16.828 15.138-16.828h240.257c9.042 0 16.091 7.836 15.138 16.828z",
  fill: "#efedef"
}), /*#__PURE__*/React.createElement("path", {
  d: "m429.272 360.785h-30.446c9.042 0 16.091 7.836 15.138 16.828l-13.439 126.776h30.446l13.439-126.776c.954-8.992-6.095-16.828-15.138-16.828z",
  fill: "#e5e1e5"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m504.5 512h-497c-4.143 0-7.5-3.358-7.5-7.5s3.357-7.5 7.5-7.5h497c4.143 0 7.5 3.358 7.5 7.5s-3.357 7.5-7.5 7.5z",
  fill: "#c9bfc8"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 309.144,
  cy: 432.587,
  fill: "#c9bfc8",
  r: 21.312
}), /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 54.014,
  cy: 80.653,
  r: 7.611
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84.46,
  cy: 80.653,
  r: 7.611
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114.906,
  cy: 80.653,
  r: 7.611
})));

var SvgCustomerService = function SvgCustomerService(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCustomerService, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/customer-service.dc8471bd.svg";
export { ForwardRef as ReactComponent };